import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../../../config/axios.config';
import { API_ENDPOINTS } from '../../../shared/api-endpoints';

export const ForgotPasswordApi: any = createAsyncThunk(
	'forgotPasswordApi',
	async ({ input, token }: { input: any; token?: { CustomToken?: string } }) => {
		try {
			let header: any = {
				'content-type': 'application/x-www-form-urlencoded'
			};
			// Add CustomToken to header only if it's provided
			if (token?.CustomToken) {
				header.CustomToken = token.CustomToken;
			}
			const { data } = await API.post(API_ENDPOINTS.FORGOT_PASSWORD, input, {
				headers: { ...header }
			});
			return data;
		} catch (forgotPassError: any) {
			return forgotPassError?.response?.data;
		}
	}
);

const ForgotPasswordSlice = createSlice({
	name: 'forgotPasswordApi',
	initialState: {
		forgotPassRes: [],
		forgotPassLoad: false,
		forgotPassError: ''
	},
	reducers: {
		reset: (state) => {
			state.forgotPassRes = [];
			state.forgotPassLoad = false;
			state.forgotPassError = '';
		}
	},
	extraReducers: (builder) => {
		builder.addCase(ForgotPasswordApi.fulfilled, (state, action: any) => {
			state.forgotPassLoad = false;
			state.forgotPassRes = action.payload;
			state.forgotPassError = '';
		});

		builder.addCase(ForgotPasswordApi.pending, (state) => {
			state.forgotPassLoad = true;
		});

		builder.addCase(ForgotPasswordApi.rejected, (state, action: any) => {
			state.forgotPassLoad = false;
			state.forgotPassRes = [];
			state.forgotPassError = action.payload;
		});
	}
});

export const { reset: resetForgotPassword } = ForgotPasswordSlice.actions;
export const ForgotPasswordApiSlice = ForgotPasswordSlice.reducer;
